export default __webpack_public_path__ + "static/media/calendar.b492ee09.svg";